import moveBookingModalButtonTemplate from './move_booking_modal_button.html';
import widgetModalTemplate from './../../public-booking/widget-modal/widget_modal.html';
import calendarTemplate from './../../public-booking/_templates/steps/calendar.html';
import mainViewBookingTemplate from './../../public-booking/_templates/steps-main/main_view_booking.html';

class bbMoveBookingModalButtonCtrl {
    constructor(bbWidgetModal, BBWidget) {
        'ngInject';
        this.bbWidgetModal = bbWidgetModal;
        this.BBWidget = BBWidget;

    }

    /*
        a booking is moved by initialising the widget in a modal and loading the calendar step
        the bookings purchase ref must be passed in to the modal to be used in widget initialisation
        after the booking is moved the confirmation step is displayed with the updated booking information
        an extra step ('reschedule reasons') may be added to the modal journey by adding moveReasons to the modalConfig object
     */

    openMoveModal() {
        const modalConfig = {
            company_id: this.booking.company_id,
            moveBookingTotalId: this.booking.purchase_ref,
            first_page: this.firstPage ? this.firstPage : calendarTemplate.id.replace('.html', ''),
            template: mainViewBookingTemplate.id.replace('.html', ''),
            templateUrl: widgetModalTemplate.id,
            size: 'lg',
            moveReasons: this.moveReasons,
        };

        this.bbWidgetModal.openModal(modalConfig);
    }
}

const bbMoveBookingModalButton = {
    templateUrl: moveBookingModalButtonTemplate.id,
    bindings: {
        booking: '<',
        moveReasons: '<',
        firstPage: '<'
    },
    controller: bbMoveBookingModalButtonCtrl,
    controllerAs: '$bbMoveBookingModalButtonCtrl'
};

angular
    .module('BBPublicBooking')
    .component('bbMoveBookingModalButton', bbMoveBookingModalButton);
export default bbMoveBookingModalButtonCtrl;



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/move-booking-modal-button/bb_move_booking_modal_button.component.js